<template>
    <DataTable :value="items" dataKey="id" :selection.sync="selectedItem" selectionMode="single" class="p-datatable-sm">
        <Column>
            <template #body="slotProps">
                <div class="flex flex-row align-items-center">
                    <div class="flex align-items-center justify-content-center full-rounded" style="width:2.5rem;height:2.5rem">
                        <img :src="slotProps.data.pair_icon_url" style="width:2.5rem;height:2.5rem" class="full-rounded" :alt="slotProps.data.pair_id"/>
                    </div>
                    <div class="text-xl ml-4">
                        {{slotProps.data.pair_name}}
                    </div>
                </div>
            </template>
        </Column>
        <Column header="Волатильность 24h" >
            <template #body="slotProps">
                <div class="text-base text-indigo-500" v-html="round(slotProps.data.volatility_day, 3)" v-if="slotProps.data.volatility_day > 0.015"></div>
                <div class="text-base text-gray-500" v-html="round(slotProps.data.volatility_day, 3)" v-else></div>
            </template>
        </Column>
        <Column header="Средний объём" >
            <template #body="slotProps">
                <div class="text-base text-indigo-500" v-html="slotProps.data.volume_hour_average + 'k'" v-if="slotProps.data.volume_hour_average > 1000"></div>
                <div class="text-base text-gray-500" v-html="slotProps.data.volume_hour_average + 'k'" v-else></div>
            </template>
        </Column>
        <Column header="Бот">
            <template #body="slotProps">
                <div class="flex flex-row align-items-center">
                    <div v-if="slotProps.data.is_active && !slotProps.data.dry_run"><span class="text-green-500"><i class="pi pi-check-circle mr-1"></i> работа</span></div>
                    <div v-if="slotProps.data.is_active && slotProps.data.dry_run"><span class="text-gray-700"><i class="pi pi-check-circle mr-1"></i> эмуляция</span></div>
                    <div v-if="!slotProps.data.is_active"><span class="text-gray-500"><i class="pi pi-clock mr-1"></i> остановлен</span></div>
                </div>
            </template>
        </Column>
        <Column header="Профит" >
            <template #body="slotProps">
                <div class="text-xl" v-html="round_colored(slotProps.data.profit_today, 2)"></div>
            </template>
        </Column>
        <Column header="Открытых сделок">
            <template #body="slotProps">
                <div :class="slotProps.data.num_open_deals >= slotProps.data.max_open_deals ? 'text-red-500' : 'text-gray-700'">
                    {{slotProps.data.num_open_deals}} из {{slotProps.data.max_open_deals}}
                </div>
            </template>
        </Column>
        <Column header="на сумму" field="sum_open_deals" ></Column>
    </DataTable>
</template>

<script>
import helperMethods from '@/helpers'
import DataTable from "primevue/datatable";
import Column from "primevue/column";

export default {
    props:{
        items: Array, // <BotPairMenuData>
        compact: Boolean,
        select: Function,
    },
    components:{
        DataTable, Column
    },
    data(){
        return {
            selectedItem: null,
        }
    },
    methods:{
        ...helperMethods,
    },
    watch:{
        selectedItem(){
            if(this.selectedItem !== null){
                //console.log(this.selectedItem)
                this.select(this.selectedItem)
                this.selectedItem = null;
            }
        }
    },
    calculated:{

    },
}

</script>
